"use strict";

const elements = {
    page_wrapper: document.querySelector(".page-wrapper"),
    table_wrapper: document.querySelector(".output-wrapper"),
    table: document.querySelector(".swiftref-table"),
    info_text: document.querySelector(".info-text"),
    pagination: document.querySelector("swiftref-pagination"),
    captcha_container: document.querySelector("#captcha-container-js"),
    searchJs: document.querySelector("#search-js"),
    // resetJs: document.querySelector("#reset-js"),
    form: document.querySelector(".form"),
    txt_file_dialog: document.querySelector("swiftref-dialog"),
    dialog_message: document.querySelector("swiftref-dialog .dialog-message-js"),
    banner_container: document.querySelector("#banner-container")
}
if (elements.captcha_container) {
    elements.refreshCaptchaButton = elements.captcha_container.querySelector("swiftref-icon");
}

module.exports = elements;
